import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import "wicg-inert";
import useProductName from "brand-customization/useProductName";
import Hotspot from "components/security/teaser/Hotspot";
import NoSidebarSearchLayout from "views/components/NoSidebarSearchLayout";
import StaticSearch from "views/components/StaticSearch";
const ReadOnlyContainer = styled.div`
  height: 100%;
`;
const DashboardOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  background: transparent;
  z-index: 1;
`;
const TeaserSearch = ({ searchJson, viewJson, searchJobResult, hotspots }) => {
  const { t } = useTranslation("users");
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(NoSidebarSearchLayout, null, /* @__PURE__ */ React.createElement(DashboardOverlay, null, hotspots.map((hotspot, index) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ React.createElement(Hotspot, { positionX: hotspot.positionX, positionY: hotspot.positionY, index, key: `hotspot-${index}` }, "descriptionKey" in hotspot ? t(hotspot.descriptionKey, { productName }) : hotspot.description)
  ))), /* @__PURE__ */ React.createElement(ReadOnlyContainer, { inert: "" }, /* @__PURE__ */ React.createElement(StaticSearch, { searchJson, viewJson, searchJobResult })));
};
export default TeaserSearch;
